export default __webpack_public_path__ + "static/media/about-dark.fd5496a7.svg";